import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Skeleton from "@material-ui/lab/Skeleton";
import { Modal as OriginalModal } from "semantic-ui-react";

import ModalTracker from "components/Modal/modalTracker";

const ModalSkeleton = () => {
  return (
    <React.Fragment>
      <OriginalModal.Header>
        <Skeleton data-test="modal-header-skeleton" />
      </OriginalModal.Header>
      <OriginalModal.Content>
        <Skeleton
          variant="rect"
          height={120}
          data-test="modal-content-skeleton"
        />
      </OriginalModal.Content>
      <OriginalModal.Actions>
        <Skeleton data-test="modal-actions-skeleton" />
      </OriginalModal.Actions>
    </React.Fragment>
  );
};

const Modal = ({ isModalOpen, isLoading, onClose, children, ...props }) => {
  return (
    <OriginalModal open={isModalOpen} {...props} onClose={onClose}>
      {isLoading ? <ModalSkeleton /> : children}
    </OriginalModal>
  );
};

Modal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  children: null,
  isLoading: false,
  onClose: () => {},
};

export function ModalWithTracker({ isModalOpen, onOpen, onClose, ...props }) {
  useEffect(() => {
    if (isModalOpen) ModalTracker.increment();
  }, [isModalOpen]);

  return (
    <Modal
      {...props}
      isModalOpen={isModalOpen}
      onOpen={() => {
        ModalTracker.increment();
        onOpen();
      }}
      onClose={() => {
        ModalTracker.decrement();
        onClose();
      }}
    />
  );
}

ModalWithTracker.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

ModalWithTracker.defaultProps = {
  onOpen: () => {},
  onClose: () => {},
};

export default Modal;
